import { CollectionSurveyQuestions } from '@src/generated/hooks';
import { validateQuestionType } from '@src/services/surveys/utils/validation';

/**
 * @name validateSubQuestion
 * @description The sub-question type just loops over its children and
 * validates each against the same rules we would otherwise.
 */
export const validateSubQuestion = (
  question: CollectionSurveyQuestions,
  answers: Record<string, any>
): string => {
  const { sub_questions = [] } = question;

  const errors: string[] = [];
  sub_questions.forEach((q) => {
    if (!q) return;

    const error = validateQuestionType(q, answers);

    if (error) {
      errors.push(error);
    }
  });

  const isValid = errors.length === 0;

  return isValid ? '' : errors[0];
};
